import { gql } from 'graphql-request';
import { TextBlockQuery } from '@blocks/text/TextBlockQuery';
import { z } from 'zod';
import {
	BlockQueryCollection,
	DatoAssetQuery,
	DatoSeoQuery,
	DatoSeoValidation,
	Query,
	QueryParamFactory
} from '@queries/datoCMS';
import { AssetBlockQuery } from '@blocks/asset/AssetBlockQuery';
import { TextSimpleBigQuery } from '@blocks/textSimpleBig/TextSimpleBigBlockQuery';
import { BlogThumbQuery } from '@queries/GlobalQuery';
import { QuoteBlockQuery } from '@blocks/quote/QuoteBlockQuery';

// Register blocks
const BlogBlocksQuery = new BlockQueryCollection([
	AssetBlockQuery,
	TextBlockQuery,
	QuoteBlockQuery,
	TextSimpleBigQuery
]);

const blogValidation = z
	.object({
		headline: z.string(),
		media: DatoAssetQuery.validation,
		content: BlogBlocksQuery.validation
	})
	.merge(DatoSeoValidation);

export const BlogsThumbnailsQuery = (params: { first?: number; skip?: number }) => {
	params.first = params.first || 9;
	params.skip = params.skip || 0;
	const queryParams = new QueryParamFactory(params).build();

	return new Query(
		gql`
			query BlogsPage {
				allBlogs ${queryParams} {
					${BlogThumbQuery}
				}
			}
		`,
		z.object({
			allBlogs: z.array(BlogThumbQuery.validation)
		})
	);
};

export const BlogPageQuery = (slug: string) => {
	return new Query(
		gql`
			query BlogPage {
				blog(filter: {slug: {eq: "${slug}"}}) {
					slug
					headline
					media {
						${DatoAssetQuery}
					} 
					content {
						${BlogBlocksQuery}
					}
					${DatoSeoQuery}
				}
			}
		`,
		z.object({
			blog: blogValidation
		})
	);
};

export type BlogPageData = z.infer<typeof blogValidation>;
export type BlogBlocksData = z.infer<typeof BlogBlocksQuery.validation>;
